import { motion } from "framer-motion";
import { STEPS } from "../../lib/site";
import { useI18n } from "../../i18n/LanguageContext";
import { Reveal, Eyebrow, staggerParent, staggerChild } from "./Reveal";
import { Icon } from "./Icon";

export const HowToBuy = () => {
  const { t } = useI18n();
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 bg-[#090c12]" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-16">
          <Reveal className="flex justify-center"><Eyebrow>{t.how.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-bold text-4xl md:text-5xl tracking-tight">{t.how.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 mx-auto max-w-lg text-slate-400 text-base leading-relaxed">{t.how.subtitle}</p>
          </Reveal>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {STEPS.map((s) => {
            const step = t.how.steps[s.n];
            return (
              <motion.div
                key={s.n}
                variants={staggerChild}
                data-testid={`step-${s.n}`}
                className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0a0e14] p-8 hover:border-cyan-500/30 transition-colors duration-300"
              >
                <span className="pointer-events-none absolute -top-6 -right-2 font-display font-black text-[7rem] leading-none text-white/[0.035] select-none">
                  {s.n}
                </span>
                <div className="relative flex items-center gap-3 mb-8">
                  <span className="font-mono text-sm text-slate-600">{s.n}</span>
                  <span className="text-cyan-400 transition-transform duration-300 group-hover:-translate-y-0.5">
                    <Icon name={s.icon} className="h-5 w-5" />
                  </span>
                </div>
                <h3 className="relative font-display font-bold text-xl">{step.title}</h3>
                <p className="relative mt-3 text-sm text-slate-400 leading-relaxed">{step.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
